var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":100,"value":_vm.loading,"opacity":"0.8"}},[_c('div',{staticClass:"parent",staticStyle:{"height":"200px","width":"200px"}},[_c('v-img',{staticClass:"loading",attrs:{"id":"loading","src":"/images/logo-round-text.png"}}),_c('v-img',{staticClass:"center",attrs:{"src":"/images/logo-fox.png"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }